import { InstaImage, InstaProfileINT } from './../../components/insta/interfaces';
import { Helper } from './../../shell/Actions/HelperFuncs';
import { produce } from 'immer';
import { RootState } from '../store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GameNames } from './GameTypes';

export interface InstaProfilesSlice {
    [key: string]: InstaProfileINT;
}

export interface TInstaINT {
    display: boolean,
    userName?: string,
    profiles: InstaProfilesSlice,
    lastUpdated?: GameNames | null,
    selectedProfile?: string,
    selectedImage?: string,
    counter: number,
}


const instaSlice = createSlice({
    name: 'insta',
    initialState: {
        display: false,
        lastUpdated: null,
        userName: "",
        counter: 0
    } as TInstaINT,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        setDisplay: (state, { payload }: PayloadAction<{ display: boolean; }>) => {
            return produce(state, draft => {
                draft.display = payload.display;
                if (payload.display) {
                    draft.lastUpdated = GameNames.INSTA;
                } else {
                    draft.lastUpdated = GameNames.SET_INSTA;

                }
            });
        },
        setInsta: (state, { payload }: PayloadAction<TInstaINT>) => {
            return produce(state, draft => {
                if (payload.profiles) {

                    // draft = { ...draft, profiles: payload.profiles };
                    draft.counter = draft.counter++;
                    draft.profiles = payload.profiles;
                }

            });
        },
        setInstaImage: (state, { payload }: PayloadAction<InstaImage>) => {
            return produce(state, draft => {
                if (draft.selectedProfile) {
                    const index = draft.profiles[draft.selectedProfile].images.findIndex(image => (image.key == payload.key));
                    if (index > -1) {

                        draft.profiles[draft.selectedProfile].images[index] = payload;
                    }
                }


            });
        },
        setSelectedProfile: (state, { payload }: PayloadAction<string>) => {
            return produce(state, draft => {
                draft.selectedProfile = payload;
            });
        },
        setSelectedImage: (state, { payload }: PayloadAction<string>) => {
            return produce(state, draft => {
                draft.selectedImage = payload;
            });
        },
        setUserName: (state, { payload }: PayloadAction<string>) => {
            return produce(state, draft => {
                draft.userName = payload;
            });
        },
        setImagesLikes: (state, { payload }: PayloadAction<{ profileName: string, profile: InstaProfileINT; }>) => {
            return produce(state, draft => {
                draft.profiles[payload.profileName] = payload.profile;
            });
        },

    },

});

export const { setInsta, setInstaImage, setSelectedProfile, setSelectedImage, setDisplay, setUserName, setImagesLikes } = instaSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectInsta = (state: RootState) => state.insta;


export default instaSlice.reducer;
